export const transferServiceLocation = [
  "Tuban",
  "Kuta",
  "Jimbaran",
  "Nusa Dua",
  "Seminyak",
  "Sanur",
  "Canggu",
  "Ubud",
  "Sawangan",
  "Uluwatu",
  "Tanah Lot",
  "Payangan",
  "Tegalalang",
  "Pemuteran",
  "Buleleng",
  "Jembrana",
  "Tabanan",
  "Denpasar",
  "Badung",
  "Gianyar",
  "Bangli",
  "Klungkung",
  "Karangasem",
];
